import { getParams }                 from 'utils/util';


export default {
  initMedscapeGlobals() {
    const empty = () => { };
    this.initGlobal('$userId',      window.s_registered_user_id, undefined);
    this.initGlobal('$metrics',     window.s_md, { });
    this.initGlobal('$wmdPageView', window.wmdPageview, empty);
    this.initGlobal('$wmdTrack',    window.wmdTrack, empty);
    this.initGlobal('$wmdPageLink', window.wmdPageLink, empty);
    this.initFromMeta('ipp');
    this.initFromMeta('cp');
    this.initFromUrlParam('cp');
    this.initFromUrlParam('ipp');
  },
  initGlobal(name, globe, fallback) {
    if(typeof globe !== 'undefined') {
      this[name] = globe;
    } else {
      this[name] = fallback;
    }
  },
  initFromMeta(name) {
    const metaElement = document.querySelector(`[data-${name}]`);
    delete this[name];
    if(metaElement !== null) {
      this[name] = JSON.parse(metaElement.getAttribute(`data-${name}`));
    }
  },
  initFromUrlParam(name) {
    const itsParams = getParams(window.location.search);
    if(typeof itsParams[name] !== 'undefined') {
      delete this[name];
      this[name] = itsParams[name];
      console.log('init from params:' + name + ':' + itsParams[name]);
    }
  }
};



/** WEBPACK FOOTER **
 ** ./modules/mixins/has_medscape_globals.js
 **/